import { render } from "./MenuSection.vue?vue&type=template&id=3cdd76c0&scoped=true"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"

import "./MenuSection.vue?vue&type=style&index=0&id=3cdd76c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cdd76c0"

export default script